/**
 * Font stacks for App Store screenshot pages.
 * Avoid Inter/Roboto here — bundled @font-face Roboto is Latin-only and breaks CJK in WebView captures.
 */

import { SCREENSHOT_LANG_ISO as LANG_HTML_CODE } from "./interfaceLang";

const LOCALE_FONT_SUFFIX = {
    korean: '"AppleGothic", "Apple SD Gothic Neo"',
    japanese: '"Hiragino Sans", "YuGothic", "Arial Unicode MS"',
    chinese: '"PingFang SC", "Hiragino Sans GB", "Heiti SC", "Arial Unicode MS"',
    hindi: '"Tiro Devanagari Hindi", "Kohinoor Devanagari", "Arial Unicode MS"',
    arabic: '"Kigelia Arabic", "Myriad Arabic", "Geeza Pro", "Damascus", "Arial Unicode MS"',
};

const LOCALE_TEXT_DIRECTION = {
    arabic: "rtl",
};

const BASE_STACK = "-apple-system, BlinkMacSystemFont, sans-serif";

export function screenshotFontStack(lang) {
    const localeFonts = LOCALE_FONT_SUFFIX[lang];
    if (localeFonts) {
        // Locale fonts first — otherwise -apple-system wins and ignores Font Book picks.
        return `${localeFonts}, ${BASE_STACK}, sans-serif`;
    }
    return `${BASE_STACK}, "Segoe UI", sans-serif`;
}

/** Shell sx so MUI Typography/Chips inherit CJK-capable fonts instead of Latin-only Roboto. */
export function screenshotShellFontSx(lang) {
    const fontFamily = screenshotFontStack(lang);
    return {
        fontFamily,
        "& .MuiTypography-root": { fontFamily: `${fontFamily} !important` },
        "& .MuiChip-root, & .MuiButton-root": { fontFamily: `${fontFamily} !important` },
        "& span": { fontFamily: `${fontFamily} !important` },
    };
}

export function applyScreenshotDocumentLang(lang) {
    if (!lang || typeof document === "undefined") return;
    try {
        document.documentElement.lang = LANG_HTML_CODE[lang] ?? "en";
        document.documentElement.dir = LOCALE_TEXT_DIRECTION[lang] ?? "ltr";
    } catch {
        /* ignore */
    }
}
